import "./Referrals.css";
import React from "react";
import { useState } from "react";
import { useLocalStorage } from "react-use";
import { Trans, t } from "@lingui/macro";
import { useWeb3React } from "@web3-react/core";
import { useParams } from "react-router-dom";
import SEO from "components/Common/SEO";
import Tab from "components/Tab/Tab";
import Loader from "components/Common/Loader";
import Footer from "components/Footer/Footer";
import { getPageTitle, isHashZero } from "lib/legacy";
import {
  useReferralsData,
  useReferralServiceData,
  registerReferralCode,
  useCodeOwner,
  useReferrerTier,
  useUserReferralCode,
  useReferralInfoData
} from "domain/referrals";
import JoinReferralCode from "components/Referrals/JoinReferralCode";
import AffiliatesStats from "components/Referrals/AffiliatesStats";
import TradersStats from "components/Referrals/TradersStats";
import AddAffiliateCode from "components/Referrals/AddAffiliateCode";
import TradingRewardsStats from "components/Referrals/TradingRewardsStats";
import { deserializeSampleStats, isRecentReferralCodeNotExpired } from "components/Referrals/referralsHelper";
import { ethers } from "ethers";
import { useLocalStorageSerializeKey } from "lib/localStorage";
import { REFERRALS_SELECTED_TAB_KEY } from "config/localStorage";
import { useChainId } from "lib/chains";
const TRADERS = t`Traders`;
const AFFILIATES = t`Affiliates`;
// const TRADINGREWARDS = t`Trading Rewards`
const TRADINGREWARDS = t`Referral Rewards`
const TAB_OPTIONS = [AFFILIATES, TRADINGREWARDS, TRADERS];

function Referrals ({ connectWallet, setPendingTxns, pendingTxns }) {
  const { active, account: walletAccount, library } = useWeb3React();
  const { account: queryAccount } = useParams();
  let account;
  if (queryAccount && ethers.utils.isAddress(queryAccount)) {
    account = ethers.utils.getAddress(queryAccount);
  } else {
    account = walletAccount;
  }
  const { chainId } = useChainId();
  const [activeTab, setActiveTab] = useLocalStorage(REFERRALS_SELECTED_TAB_KEY, TRADERS);
  const { data: referralsData, loading } = useReferralsData(chainId, account);
  const { data: referralServiceData,loading:serviceLoading} = useReferralServiceData(chainId, account);
  // fix
  const [recentlyAddedCodes, setRecentlyAddedCodes] = useLocalStorageSerializeKey([chainId, "REFERRAL", account], [], {
    deserializer: deserializeSampleStats,
  });
  const [  userReferralCodes,setUserReferralCodes ] = useState(false);
  const { userReferralCode, userReferralCodeString } = useUserReferralCode(library, chainId,account,userReferralCodes);
  const { data: referralInfoData}= useReferralInfoData(chainId,userReferralCodeString);
  const { codeOwner } = useCodeOwner(library, chainId, account, userReferralCode);
  const { referrerTier: traderTier } = useReferrerTier(library, chainId, codeOwner);



  function handleCreateReferralCode (referralCode) {
    return registerReferralCode(chainId, referralCode, library, {
      sentMsg: t`Referral code submitted!`,
      failMsg: t`Referral code creation failed.`,
      pendingTxns,
    });
  }

  function renderAffiliatesTab () {
    const isReferralCodeAvailable = referralServiceData.addressBycode.code == "-";
    if (serviceLoading) return <Loader />;
    if (loading) return <Loader />;
    if (!isReferralCodeAvailable ) {
      return (
        <AffiliatesStats
          referralsData={referralsData}
          userReferrerReward={referralServiceData.userReferrerReward}
          userTradeReward={referralServiceData.userTradeReward}
          handleCreateReferralCode={handleCreateReferralCode}
          setRecentlyAddedCodes={setRecentlyAddedCodes}
          addressBycode={referralServiceData.addressBycode}
          recentlyAddedCodes={recentlyAddedCodes}
          chainId={chainId}
        />
      );
    } else {
      return (
        <AddAffiliateCode
          handleCreateReferralCode={handleCreateReferralCode}
          active={active}
          connectWallet={connectWallet}
          recentlyAddedCodes={recentlyAddedCodes}
          setRecentlyAddedCodes={setRecentlyAddedCodes}
          referralsData={referralsData}
        />
      );
    }
  }

  function renderTradersTab () {
    if (serviceLoading) return <Loader />;
    if (loading) return <Loader />;
    if (isHashZero(userReferralCode) || !account || !userReferralCode) {
      return (
        <JoinReferralCode
          connectWallet={connectWallet}
          active={active}
          setPendingTxns={setPendingTxns}
          pendingTxns={pendingTxns}
          setUserReferralCodes={setUserReferralCodes}
        />
      );
    }
    return (
      <TradersStats
        userReferralCodeString={userReferralCodeString}
        chainId={chainId}
        referralInfoData={referralInfoData}
        userTradeReward={referralServiceData.userTradeReward}
        referralsData={referralsData}
        setPendingTxns={setPendingTxns}
        pendingTxns={pendingTxns}
        traderTier={traderTier}
        setUserReferralCodes={setUserReferralCodes}
      />
    );
  }

  function RenderTradingRewards () {

    if (serviceLoading) return <Loader />;
    if (loading) return <Loader />;
    return (
      <TradingRewardsStats
        userReferralCodeString={userReferralCodeString}
        userEarlyReward={referralServiceData.userEarlyReward}
        chainId={chainId}
        referralsData={referralsData}
      />
    )
  }
  return (
    <SEO title={getPageTitle("Referrals")}>
      <div className="default-container page-layout Referrals">
        <div className="section-title-block">
          <div className="section-title-icon"></div>
          <div className="section-title-content">
            <div className="Page-title">
              <Trans>Referrals</Trans>
            </div>
            {/* <div className="Page-description">
              <Trans>
                Get fee discounts and earn rebates through the AVT referral program.
                <br />
                For more information, please read the{" "}
                <a href="/#" onClick={(e) => e.preventDefault()} rel="noopener noreferrer">
                  referral program details
                </a>
                .
              </Trans>
            </div> */}
            <div className="Page-description">
              <Trans>
                Earn attractive AVT rewards and enjoy trading fee discounts through{" "}
                <a href="https://docs.avt.trade" target="_blank" rel="noopener noreferrer">
                  AVT Refer & Earn Program
                </a>
                .
              </Trans>
            </div>
          </div>
        </div>
        <div className="referral-tab-container">
          <Tab options={TAB_OPTIONS} option={activeTab} setOption={setActiveTab} onChange={setActiveTab} />
        </div>
        {/* {activeTab === AFFILIATES ? renderAffiliatesTab() : (
          activeTab === TRADERS
            ? renderTradersTab()
            : RenderTradingRewards()
        )} */}
        {activeTab === AFFILIATES ? renderTradersTab() : (activeTab === TRADERS ? RenderTradingRewards() : renderAffiliatesTab())}
      </div>
      <Footer />
    </SEO>
  );
}

export default Referrals;
